// import React, { useState } from "react";
// import { connect } from 'react-redux'
// import { Typography, Button, Tag } from "antd";
// import moment from "moment";
// import SavingModal from 'components/SavingModal'
// import { deleteSchedule, cancelSchedule, fetchSchedule, fetchScheduleFilter, fetchTimetableData } from 'actions/schedule'
// import { EventRegister } from 'react-native-event-listeners'

// const { Text } = Typography;

// /* ---------- STYLES ---------- */

// const containerStyle = {
//   background: "#F4F0FF",
//   borderRadius: 12,
//   padding: 16,
//   marginBottom: 16,
// };

// const labelStyle = {
//   fontFamily: "Roboto",
//   fontSize: 12,
//   fontWeight: 400,
//   lineHeight: "100%",
//   color: "#636363",
//   marginBottom: 6,
// };

// const valueStyle = {
//   fontFamily: "Roboto",
//   fontSize: 14,
//   fontWeight: 400,
//   lineHeight: "100%",
//   color: "#191919",
// };

// const repeatCircle = {
//   width: 51,
//   height: 51,
//   borderRadius: "50%",
//   background: "#F4F0FF",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   fontFamily: "Roboto",
//   fontSize: 14,
//   color: "#594099",
// };

// const actionBtn = (color) => ({
//   width: "100%",
//   height: 45,
//   borderRadius: 8,
//   border: `1px solid ${color}`,
//   color,
//   fontFamily: "Roboto",
//   fontSize: 14,
//   fontWeight: 500,
// });

// /* ---------- DAY MAP ---------- */

// const dayMap = {
//   sunday: "Su",
//   monday: "Mo",
//   tuesday: "Tu",
//   wednesday: "We",
//   thursday: "Th",
//   friday: "Fr",
//   saturday: "Sa",
// };

// const ScheduleDetailsTab = ({ schedule, onEdit, deleteSchedule, cancelSchedule, fetchSchedule, fetchScheduleFilter, fetchTimetableData, tabType, stdTimetable, currentDate, teacherSearch, classFilter, subFilter, showModal, setShowModal, modalConfig, setModalConfig }) => {
//   const data = schedule?.schedule || schedule;

//   if (!data) {
//     return (
//       <div style={{ padding: 24 }}>
//         <Text type="danger">No schedule data received</Text>
//       </div>
//     );
//   }

//   return (
//     <div style={{ padding: 24 }}>
//       {/* SUBJECT */}
//       <div style={containerStyle}>
//         <div style={labelStyle}>Subject</div>
//         <div style={valueStyle}>{data?.subject?.name || "—"}</div>
//       </div>

//       {/* BATCH */}
//       <div style={containerStyle}>
//         <div style={labelStyle}>Batch</div>
//         {(data?.standards || []).map((b, i) => (
//           <Tag
//             key={i}
//             style={{
//               background: "#F4F0FF",
//               border: "1px solid #594099",
//               color: "#594099",
//               borderRadius: 6,
//             }}
//           >
//             {b.std}-{b.section}
//           </Tag>
//         ))}
//       </div>

//       {/* INSTRUCTOR */}
//       <div style={containerStyle}>
//         <div style={labelStyle}>Instructor</div>
//         <div style={valueStyle}>{data?.teacher?.name || "—"}</div>
//       </div>

//       {/* MODE */}
//       <div style={{ marginBottom: 16 }}>
//         <div style={labelStyle}>Mode of class</div>
//         <Tag
//           style={{
//             background: "#F4F0FF",
//             border: "1px solid #594099",
//             color: "#594099",
//           }}
//         >
//           {data?.mode || "—"}
//         </Tag>
//       </div>

//       {/* DATES */}
//       <div style={{ display: "flex", gap: 16 }}>
//         <div style={{ flex: 1, ...containerStyle }}>
//           <div style={labelStyle}>Start date</div>
//           <div style={valueStyle}>
//             {data?.startDate
//               ? moment(data.startDate).format("DD/MM/YYYY")
//               : "—"}
//           </div>
//         </div>

//         <div style={{ flex: 1, ...containerStyle }}>
//           <div style={labelStyle}>Last date</div>
//           <div style={valueStyle}>
//             {data?.endDate
//               ? moment(data.endDate).format("DD/MM/YYYY")
//               : "—"}
//           </div>
//         </div>
//       </div>

//       {/* TIME */}
//       <div style={{ display: "flex", gap: 16 }}>
//         <div style={{ flex: 1, ...containerStyle }}>
//           <div style={labelStyle}>Start time</div>
//           <div style={valueStyle}>
//             {data?.startTime
//               ? moment(data.startTime, "HH:mm:ss").format("hh:mm A")
//               : "—"}
//           </div>
//         </div>

//         <div style={{ flex: 1, ...containerStyle }}>
//           <div style={labelStyle}>End time</div>
//           <div style={valueStyle}>
//             {data?.endTime
//               ? moment(data.endTime, "HH:mm:ss").format("hh:mm A")
//               : "—"}
//           </div>
//         </div>
//       </div>

//       {/* REPEAT ON */}
//       <div style={{ marginTop: 16 }}>
//         <div style={labelStyle}>Repeat on</div>
//         <div style={{ display: "flex", gap: 10 }}>
//           {(data?.weekdays || []).map((d) => (
//             <div key={d} style={repeatCircle}>
//               {dayMap[d]}
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* ACTION BUTTONS */}
//       <div style={{ marginTop: 32 }}>
//         <Button style={{ ...actionBtn("#594099"), marginBottom: 12 }} onClick={onEdit}>
//           EDIT SCHEDULE
//         </Button>

//         <Button style={{ ...actionBtn("#FF9500"), marginBottom: 12 }} onClick={() => { setModalConfig({ type: 'cancelOccurance', title: "Cancel Today's Class", message: "Are you sure you want to cancel today's class?", confirmText: 'YES' }); setShowModal(true); }}>
//           CANCEL TODAY’S CLASS
//         </Button>

//         <Button style={actionBtn("#FF414D")} onClick={() => { setModalConfig({ type: 'deleteSchedule', title: 'Delete Entire Schedule', message: 'Are you sure you want to delete the entire schedule?', confirmText: 'DELETE' }); setShowModal(true); }}>
//           DELETE ENTIRE SCHEDULE
//         </Button>
//       </div>

//       <SavingModal
//         visible={showModal}
//         title={modalConfig.title}
//         message={modalConfig.message}
//         confirmText={modalConfig.confirmText}
//         cancelText={'NO'}
//         onCancel={() => setShowModal(false)}
//         onConfirm={async () => {
//           setShowModal(false)
//           const id = data?.scheduleId || data?.id
//           try {
//             if (modalConfig.type === 'deleteSchedule') {
//               await deleteSchedule(id)
//             } else if (modalConfig.type === 'cancelOccurance') {
//               await cancelSchedule(id)
//             }
//             EventRegister.emit('apicall:scheduleHome')
//             if (tabType === 'schedule') {
//               if (currentDate === moment().format('DD/MM/YYYY')) {
//                 fetchSchedule()
//               } else {
//                 fetchScheduleFilter(currentDate ? moment(currentDate, 'DD/MM/YYYY').format('YYYY-MM-DD') : '', teacherSearch, classFilter, subFilter)
//               }
//             } else if (tabType === 'timetable') {
//               fetchTimetableData(stdTimetable)
//             }
//           } catch (e) {
//             // ignore errors here, existing flow handles notifications elsewhere
//           }
//         }}
//       />
//     </div>
//   );
// };

// // local state for modal
// const withModalState = (Component) => (props) => {
//   const [showModal, setShowModal] = useState(false)
//   const [modalConfig, setModalConfig] = useState({ type: '', title: '', message: '', confirmText: 'YES' })
//   return <Component {...props} showModal={showModal} setShowModal={setShowModal} modalConfig={modalConfig} setModalConfig={setModalConfig} />
// }

// const mapStateToProps = (state) => {
//   const { tabType, stdTimetable, currentDate, teacherSearch, classFilter, subFilter } = state.schedule
//   return { tabType, stdTimetable, currentDate, teacherSearch, classFilter, subFilter }
// }

// const mapDispatchToProps = (dispatch) => ({
//   deleteSchedule: (id) => dispatch(deleteSchedule(id)),
//   cancelSchedule: (id) => dispatch(cancelSchedule(id)),
//   fetchSchedule: () => dispatch(fetchSchedule()),
//   fetchScheduleFilter: (date, topic, std, sub) => dispatch(fetchScheduleFilter(date, topic, std, sub)),
//   fetchTimetableData: (std) => dispatch(fetchTimetableData(std)),
// })

// export default connect(mapStateToProps, mapDispatchToProps)(withModalState(ScheduleDetailsTab));


import React, { useState, useEffect } from "react";
import { connect } from 'react-redux'
import { Typography, Button, Tag, Tooltip } from "antd";
import moment from "moment";
import SavingModal from 'components/SavingModal'
import { deleteSchedule, cancelSchedule, fetchSchedule, fetchScheduleFilter, fetchTimetableData } from 'actions/schedule'
import { EventRegister } from 'react-native-event-listeners'
import { getSchedulePermissions } from './schedulePermissions'

const { Text } = Typography;

/* ---------- STYLES ---------- */

const containerStyle = {
  background: "#F4F0FF",
  borderRadius: 12,
  padding: 16,
  marginBottom: 16,
};

const labelStyle = {
  fontFamily: "Roboto",
  fontSize: 12,
  fontWeight: 400,
  lineHeight: "100%",
  color: "#636363",
  marginBottom: 6,
};

const valueStyle = {
  fontFamily: "Roboto",
  fontSize: 14,
  fontWeight: 400,
  lineHeight: "100%",
  color: "#191919",
};

const repeatCircle = {
  width: 51,
  height: 51,
  borderRadius: "50%",
  background: "#F4F0FF",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontFamily: "Roboto",
  fontSize: 14,
  color: "#594099",
};

const actionBtn = (color) => ({
  width: "100%",
  height: "var(--btn-height)",
  borderRadius: 12,
  border: `1px solid ${color}`,
  color,
  fontFamily: "Roboto",
  fontSize: "var(--font-size-button)",
  fontWeight: 700,
  transition: "all 0.2s ease",
});

const dayMap = {
  sunday: "Su",
  monday: "Mo",
  tuesday: "Tu",
  wednesday: "We",
  thursday: "Th",
  friday: "Fr",
  saturday: "Sa",
};

const detailsStyles = `
  :root {
    --container-padding: 8px 16px;
    --container-margin: 16px;
    --label-margin: 10px;
    --font-size-label: 12px;
    --font-size-value: 14px;
    --font-size-button: 16px;
    --btn-height: 45px;
    --repeat-circle-size: 51px;
    --repeat-circle-font: 16px;
    --row-gap: 24px;
    --wrapper-padding: 24px 40px;
    --container-min-height: 59px;
  }

  /* Responsive tiers used to live here as @media (max-height: ...) rules. Browser zoom
     shrinks the CSS-pixel viewport exactly like a physically short window does, so those
     rules couldn't tell "zoomed in" apart from "small screen" - zooming in on an ordinary
     desktop window was enough to trigger the same cramped padding and forced single-column
     date/time rows meant for tiny windows. getResponsiveDetailsVars() below computes the
     same tiers from window.outerHeight instead (the physical window size, unaffected by
     zoom) and applies them as inline CSS variables on .schedule-details-wrapper, so this
     now only kicks in for an actually short window, at any zoom level. */

  .schedule-details-wrapper {
    padding: var(--wrapper-padding);
    height: 100%;
    overflow-y: auto !important;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .detail-container {
    background: #F4F0FF;
    border-radius: 12px;
    padding: var(--container-padding);
    margin-bottom: var(--container-margin);
  }

  .detail-label {
    font-family: "Roboto";
    font-size: var(--font-size-label);
    font-weight: 400;
    line-height: 100%;
    color: #636363;
    margin-bottom: var(--label-margin);
  }

  .detail-value {
    font-family: "Roboto";
    font-size: var(--font-size-value);
    font-weight: 400;
    line-height: 100%;
    color: #191919;
  }

  .repeat-circle {
    width: var(--repeat-circle-size);
    height: var(--repeat-circle-size);
    border-radius: 50%;
    background: #F4F0FF;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "Roboto";
    font-size: var(--repeat-circle-font);
    color: #191919;
    transition: all 0.2s ease;
  }

  .flex-row-responsive {
    display: flex;
    gap: var(--row-gap);
    margin-bottom: var(--container-margin);
  }
`;

if (typeof document !== 'undefined') {
  const styleElement = document.createElement('style');
  styleElement.type = 'text/css';
  styleElement.appendChild(document.createTextNode(detailsStyles));
  document.head.appendChild(styleElement);
}

// Same tier thresholds the old @media (max-height: ...) rules used, but keyed off
// window.outerHeight (the physical browser window, unaffected by page zoom) instead of
// the CSS viewport height (which shrinks under zoom exactly like a short window would).
// Tiers layer additively, same as the media queries did, from least to most compact.
const getResponsiveDetailsVars = () => {
  const oh = typeof window !== 'undefined' && window.outerHeight ? window.outerHeight : 1080;
  let vars = {
    '--container-padding': '8px 16px',
    '--container-margin': '16px',
    // 40px left/right per spec (592px panel - 80px = 512px content width).
    '--wrapper-padding': '24px 40px',
    '--btn-height': '45px',
    '--font-size-value': '16px',
    '--font-size-label': '16px',
    '--font-size-button': '18px',
  };
  let stackRows = false;
  if (oh <= 950) {
    vars = { ...vars, '--container-padding': '12px', '--wrapper-padding': '20px 24px', '--btn-height': '40px' };
  }
  if (oh <= 850) {
    vars = { ...vars, '--container-padding': '10px', '--wrapper-padding': '16px 20px', '--font-size-value': '15px' };
  }
  if (oh <= 700) {
    vars = { ...vars, '--container-padding': '8px', '--wrapper-padding': '12px 18px', '--font-size-label': '15px', '--font-size-button': '14px' };
    stackRows = true;
  }
  if (oh <= 650) {
    vars = { ...vars, '--container-padding': '6px', '--container-margin': '4px', '--wrapper-padding': '8px 16px', '--btn-height': '30px' };
  }
  return { vars, stackRows };
};

const ScheduleDetailsTab = ({ schedule, onEdit, onClose, deleteSchedule, cancelSchedule, fetchSchedule, fetchScheduleFilter, fetchTimetableData, tabType, stdTimetable, currentDate, isToday, teacherSearch, classFilter, subFilter, showModal, setShowModal, modalConfig, setModalConfig, user, togglePageLoader, pageLoader, isCompletedClass, isOngoingClass, isCancelledClass }) => {
  // Editing, cancelling and deleting a schedule are all the matrix's "Creation" column -
  // no creation means no editing details either - so they live and die together on
  // canCreate: Admin, Planner, SuperAdmin.
  //
  // This used to read `access` out of state.schedule, which only records that the user
  // landed on the admin Schedule view at all (schedule.js sets it for AttendanceMarker
  // too). That made every one of these buttons visible to an Operation + AttendanceMarker,
  // whose Creation cell is "No" - and because this component is connect()ed, the redux
  // value silently overrode whatever `access` a parent passed down as a prop, so gating it
  // at the card was never going to take effect.
  const canEditSchedule = getSchedulePermissions(user).canCreate;
  const data = {
    ...schedule,
    ...(schedule?.schedule || {}),
    subject: schedule?.subject || schedule?.schedule?.subject,
    teacher: schedule?.teacher || schedule?.schedule?.teacher,
    standards: schedule?.standards?.length ? schedule.standards : (schedule?.schedule?.standards || []),
    startTime: schedule?.startTime || schedule?.schedule?.startTime,
    endTime: schedule?.endTime || schedule?.schedule?.endTime,
    mode: schedule?.mode || schedule?.schedule?.mode
  };

  const [responsive, setResponsive] = useState(getResponsiveDetailsVars);
  useEffect(() => {
    const onResize = () => setResponsive(getResponsiveDetailsVars());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  if (!data) {
    return (
      <div style={{ padding: 24 }}>
        <Text type="danger">No schedule data received</Text>
      </div>
    );
  }

  return (
    <div className="schedule-details-wrapper" style={responsive.vars}>
      {/* SUBJECT */}
      <div style={{
        width: '100%',
        minHeight: 'var(--container-min-height)',
        background: '#F4F0FF',
        borderRadius: 12,
        padding: 'var(--container-padding)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        marginBottom: 'var(--container-margin)',
        boxSizing: 'border-box',
        flexShrink: 0
      }}>
        <div style={{
          fontFamily: 'Roboto',
          fontWeight: 500,
          fontSize: 'var(--font-size-label)',
          lineHeight: '100%',
          color: '#636363',
          marginBottom: 'var(--label-margin)',
          display: 'flex',
          alignItems: 'center'
        }}>
          Subject
        </div>
        <div
          title={data?.subject?.name || "—"}
          style={{
            width: '100%',
            fontFamily: 'Roboto',
            fontWeight: 500,
            fontSize: 'var(--font-size-value)',
            lineHeight: 'normal',
            color: '#191919',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            // Not display:'flex'. text-overflow only applies to a block box with
            // inline content, so making this value a flex container blockified the
            // text and a long name was hard-clipped mid-word with no '...'. Batch
            // below never had it and has always ellipsised correctly.
            display: 'block'
          }}
        >
          {data?.subject?.name || "—"}
        </div>
      </div>

      {/* BATCH */}
      <div style={{
        width: '100%',
        minHeight: 'var(--container-min-height)',
        background: '#F4F0FF',
        borderRadius: 12,
        padding: 'var(--container-padding)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        marginBottom: 'var(--container-margin)',
        boxSizing: 'border-box',
        flexShrink: 0
      }}>
        <div style={{
          fontFamily: 'Roboto',
          fontWeight: 500,
          fontSize: 'var(--font-size-label)',
          lineHeight: '100%',
          color: '#636363',
          marginBottom: 'var(--label-margin)',
          display: 'flex',
          alignItems: 'center'
        }}>
          Batch
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, overflow: 'hidden' }}>
          {(data?.standards || []).map((b, i) => {
            const batchName = `${b.std} : ${b.section}`;
            return (
              <div
                title={batchName}
                key={i}
                style={{
                  fontFamily: 'Roboto',
                  fontWeight: 500,
                  fontSize: 'var(--font-size-value)',
                  lineHeight: 'normal',
                  color: '#191919',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  width: '100%'
                }}
              >
                {batchName}
              </div>
            )
          })}
        </div>
      </div>

      {/* INSTRUCTOR */}
      <div style={{
        width: '100%',
        minHeight: 'var(--container-min-height)',
        background: '#F4F0FF',
        borderRadius: 12,
        padding: 'var(--container-padding)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        marginBottom: 'var(--container-margin)',
        boxSizing: 'border-box',
        flexShrink: 0
      }}>
        <div style={{
          fontFamily: 'Roboto',
          fontWeight: 500,
          fontSize: 'var(--font-size-label)',
          lineHeight: '100%',
          color: '#636363',
          marginBottom: 'var(--label-margin)',
          display: 'flex',
          alignItems: 'center'
        }}>
          Instructor
        </div>
        <div
          title={data?.teacher?.name || "—"}
          style={{
            width: '100%',
            fontFamily: 'Roboto',
            fontWeight: 500,
            fontSize: 'var(--font-size-value)',
            lineHeight: 'normal',
            color: '#191919',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            // Same as Subject above - display:'flex' suppresses the ellipsis.
            display: 'block'
          }}
        >
          {data?.teacher?.name || "—"}
        </div>
      </div>

      {/* MODE */}
      <div style={{ marginBottom: 'var(--container-margin)' }}>
        <div style={{
          fontFamily: 'Roboto',
          fontWeight: 500,
          fontSize: 'var(--font-size-label)',
          lineHeight: '100%',
          color: '#636363',
          marginBottom: 'var(--label-margin)',
          display: 'flex',
          alignItems: 'center'
        }}>
          Mode of class
        </div>
        <Tag
          style={{
            height: 'var(--btn-height)',
            background: "var(--label-bg-modal, #F4F0FF)",
            border: "none",
            color: "#191919",
            borderRadius: 12,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "Roboto",
            fontSize: 'var(--font-size-value)',
            fontWeight: 500,
            textTransform: 'capitalize',
            padding: '8px 32px',
            margin: 0
          }}
        >
          {data?.mode === 'Broadcast' ? 'Online' : (data?.mode || "—")}
        </Tag>
      </div>

      {/* DATES */}
      <div className="flex-row-responsive" style={{ gap: 'var(--row-gap)', marginBottom: 'var(--container-margin)', flexDirection: responsive.stackRows ? 'column' : 'row' }}>
        <div style={{
          flex: 1,
          minHeight: 'var(--container-min-height)',
          background: '#F4F0FF',
          borderRadius: 12,
          padding: 'var(--container-padding)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          boxSizing: 'border-box'
        }}>
          <div style={{
            fontFamily: 'Roboto',
            fontWeight: 500,
            fontSize: 'var(--font-size-label)',
            lineHeight: '100%',
            color: '#636363',
            marginBottom: 'var(--label-margin)',
            display: 'flex',
            alignItems: 'center'
          }}>
            Start date
          </div>
          <div style={{
            fontFamily: 'Roboto',
            fontWeight: 500,
            fontSize: 'var(--font-size-value)',
            lineHeight: '100%',
            color: '#191919',
            display: 'flex',
            alignItems: 'center'
          }}>
            {data?.startDate
              ? moment(data.startDate).format("DD/MM/YYYY")
              : "—"}
          </div>
        </div>

        <div style={{
          flex: 1,
          minHeight: 'var(--container-min-height)',
          background: '#F4F0FF',
          borderRadius: 12,
          padding: 'var(--container-padding)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          boxSizing: 'border-box'
        }}>
          <div style={{
            fontFamily: 'Roboto',
            fontWeight: 500,
            fontSize: 'var(--font-size-label)',
            lineHeight: '100%',
            color: '#636363',
            marginBottom: 'var(--label-margin)',
            display: 'flex',
            alignItems: 'center'
          }}>
            End date
          </div>
          <div style={{
            fontFamily: 'Roboto',
            fontWeight: 500,
            fontSize: 'var(--font-size-value)',
            lineHeight: '100%',
            color: '#191919',
            display: 'flex',
            alignItems: 'center'
          }}>
            {data?.endDate
              ? moment(data.endDate).format("DD/MM/YYYY")
              : "—"}
          </div>
        </div>
      </div>

      {/* TIME */}
      <div className="flex-row-responsive" style={{ gap: 'var(--row-gap)', marginBottom: 'var(--container-margin)', flexDirection: responsive.stackRows ? 'column' : 'row' }}>
        <div style={{
          flex: 1,
          minHeight: 'var(--container-min-height)',
          background: '#F4F0FF',
          borderRadius: 12,
          padding: 'var(--container-padding)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          boxSizing: 'border-box'
        }}>
          <div style={{
            fontFamily: 'Roboto',
            fontWeight: 500,
            fontSize: 'var(--font-size-label)',
            lineHeight: '100%',
            color: '#636363',
            marginBottom: 'var(--label-margin)',
            display: 'flex',
            alignItems: 'center'
          }}>
            Start time
          </div>
          <div style={{
            fontFamily: 'Roboto',
            fontWeight: 500,
            fontSize: 'var(--font-size-value)',
            lineHeight: '100%',
            color: '#191919',
            display: 'flex',
            alignItems: 'center'
          }}>
            {data?.startTime
              ? moment(data.startTime, "HH:mm:ss").format("hh:mm A")
              : "—"}
          </div>
        </div>

        <div style={{
          flex: 1,
          minHeight: 'var(--container-min-height)',
          background: '#F4F0FF',
          borderRadius: 12,
          padding: 'var(--container-padding)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          boxSizing: 'border-box'
        }}>
          <div style={{
            fontFamily: 'Roboto',
            fontWeight: 500,
            fontSize: 'var(--font-size-label)',
            lineHeight: '100%',
            color: '#636363',
            marginBottom: 'var(--label-margin)',
            display: 'flex',
            alignItems: 'center'
          }}>
            End time
          </div>
          <div style={{
            fontFamily: 'Roboto',
            fontWeight: 500,
            fontSize: 'var(--font-size-value)',
            lineHeight: '100%',
            color: '#191919',
            display: 'flex',
            alignItems: 'center'
          }}>
            {data?.endTime
              ? moment(data.endTime, "HH:mm:ss").format("hh:mm A")
              : "—"}
          </div>
        </div>
      </div>

      {/* REPEAT ON */}
      <div style={{ marginBottom: 'var(--container-margin)' }}>
        <div style={{
          fontFamily: 'Roboto',
          fontWeight: 500,
          fontSize: 'var(--font-size-label)',
          lineHeight: '100%',
          color: '#636363',
          marginBottom: 'var(--label-margin)',
          display: 'flex',
          alignItems: 'center'
        }}>
          Repeat on
        </div>
        <div style={{ display: "flex", gap: '10px', flexWrap: 'wrap' }}>
          {(data?.weekdays || []).map((d) => (
            <div key={d} className="repeat-circle">
              {dayMap[d]}
            </div>
          ))}
        </div>
      </div>

      {/* ACTION BUTTONS (only for users with edit access).
          A completed class shows none of them. Edit and cancel were already hidden -
          there is nothing left to change on a class that has already happened - and
          DELETE ENTIRE SCHEDULE is hidden too: it deletes the whole recurring series,
          which is not an action that belongs on a single past occurrence. The series
          is still deletable from any of its scheduled (not yet run) occurrences.
          With all four buttons gone the container itself has nothing to hold, so it
          is gated here rather than leaving an empty padded block behind. */}
      {canEditSchedule && !isCompletedClass && !isCancelledClass ? (
        <div style={{ marginTop: "auto", paddingTop: "var(--container-margin)", flexShrink: 0 }}>
          {!isOngoingClass && !isCompletedClass && (
            <Button
              style={{ ...actionBtn("#594099"), marginBottom: 20, opacity: pageLoader ? 0.7 : 1 }}
              onClick={() => onEdit('occurrence')}
              disabled={pageLoader}
            >
              {isToday ? "EDIT TODAY'S CLASS" : "EDIT THIS CLASS"}
            </Button>
          )}

          {!isOngoingClass && !isCompletedClass && (
            <Button
              style={{ ...actionBtn("#594099"), marginBottom: 20, opacity: pageLoader ? 0.7 : 1 }}
              onClick={() => onEdit('schedule')}
              disabled={pageLoader}
            >
              EDIT ENTIRE SCHEDULE
            </Button>
          )}

          {!isCompletedClass && (
            <Button
              style={{ ...actionBtn("#FF9500"), marginBottom: isOngoingClass ? 0 : 20, opacity: pageLoader ? 0.7 : 1 }}
              onClick={() => { setModalConfig({ type: 'cancelOccurance', title: "Confirm", message: `Are you sure you want to cancel ${isToday ? "today's" : "this"} class?`, confirmText: 'YES' }); setShowModal(true); }}
              disabled={pageLoader}
            >
              {isToday ? "CANCEL TODAY'S CLASS" : "CANCEL CLASS"}
            </Button>
          )}

          {!isOngoingClass && (
            <Button
              style={{ ...actionBtn("#FF414D"), opacity: pageLoader ? 0.7 : 1 }}
              onClick={() => { setModalConfig({ type: 'deleteSchedule', title: 'Confirm', message: 'Are you sure you want to delete the entire schedule?', confirmText: 'YES' }); setShowModal(true); }}
              disabled={pageLoader}
            >
              DELETE ENTIRE SCHEDULE
            </Button>
          )}
        </div>
      ) : null}

      <SavingModal
        visible={showModal}
        title={modalConfig.title}
        message={modalConfig.message}
        confirmText={modalConfig.confirmText}
        cancelText={'NO'}
        onCancel={() => setShowModal(false)}
        onConfirm={async () => {
          setShowModal(false)
          const isDelete = modalConfig.type === 'deleteSchedule'
          if (togglePageLoader) togglePageLoader(true)
          // Robust ID extraction: Prioritize specific occurrence fields to avoid series ID (42) being used instead of instance ID (369)
          const seriesId = schedule?.schedule?.id || data?.scheduleId || data?.id;
          const occurrenceId = schedule?.occurrenceId || schedule?.occuranceId || schedule?.id || data?.occurrenceId || data?.occurrence_id || data?.id;

          try {
            if (isDelete) {
              await deleteSchedule(seriesId)
            } else if (modalConfig.type === 'cancelOccurance') {
              await cancelSchedule(occurrenceId)
            }
            EventRegister.emit('apicall:scheduleHome')
            if (tabType === 'timetable') {
              fetchTimetableData(stdTimetable)
            }
          } catch (e) {
            // ignore errors here, existing flow handles notifications elsewhere
          }
          if (togglePageLoader) togglePageLoader(false)
          if (onClose) onClose()
        }}
      />
    </div>
  );
};

// local state for modal
const withModalState = (Component) => (props) => {
  const [showModal, setShowModal] = useState(false)
  const [modalConfig, setModalConfig] = useState({ type: '', title: '', message: '', confirmText: 'YES' })
  return <Component {...props} showModal={showModal} setShowModal={setShowModal} modalConfig={modalConfig} setModalConfig={setModalConfig} />
}

const mapStateToProps = (state) => {
  const { tabType, stdTimetable, currentDate, teacherSearch, classFilter, subFilter } = state.schedule
  const isToday = !currentDate || moment(currentDate, ['DD MMM YYYY', 'DD/MM/YYYY', 'YYYY-MM-DD']).isSame(moment(), 'day');
  return { tabType, stdTimetable, currentDate, isToday, teacherSearch, classFilter, subFilter, user: state.session.user }
}

const mapDispatchToProps = (dispatch) => ({
  deleteSchedule: (id) => dispatch(deleteSchedule(id)),
  cancelSchedule: (id) => dispatch(cancelSchedule(id)),
  fetchSchedule: () => dispatch(fetchSchedule()),
  fetchScheduleFilter: (date, topic, std, sub) => dispatch(fetchScheduleFilter(date, topic, std, sub)),
  fetchTimetableData: (std) => dispatch(fetchTimetableData(std)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withModalState(ScheduleDetailsTab));